<template>
  <div class="subscription-card">
    <div class="subscription-header">
      <h3>{{ program.name }}</h3>
      <el-tag :type="program.status === 'active' ? 'success' : 'info'">
        {{ program.status }}
      </el-tag>
    </div>
    <div class="subscription-content">
      <p class="description">{{ program.description }}</p>
      <div class="price-info">
        <span class="price">${{ program.usd_price }}</span>
        <span class="period">/ {{ program.recurring_period }}</span>
      </div>
    </div>
    <div class="subscription-actions">
      <el-button
        v-if="program.user_id === user_id && program.content_type === 'generative'"
        type="success"
        size="small"
        @click="$emit('generate', program)"
      >
        Generate
      </el-button>
      <el-button type="primary" size="small" @click="$emit('edit', program)" v-if="program.user_id === user_id">
        Edit
      </el-button>
      <el-button type="primary" size="small" @click="$emit('subscribe', program)" v-if="program.user_id !== user_id">
        Subscribe
      </el-button>
    </div>
  </div>
</template>

<script>
import { getUserId } from '@/utils/store'
export default {
  name: 'SubscriptionProgram',
  props: {
    program: {
      type: Object,
      required: true,
      default: () => ({
        name: '',
        description: '',
        usd_price: 0,
        status: 'inactive',
        recurring_period: 'monthly',
        user_id:getUserId()
      })
    }
  },
  data() {
    return {
      user_id: getUserId()
    }
  }
}
</script>

<style scoped>
.subscription-card {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.subscription-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.subscription-header h3 {
  margin: 0;
  font-size: 18px;
  color: #303133;
}

.subscription-content {
  flex: 1;
}

.description {
  color: #606266;
  margin-bottom: 15px;
  line-height: 1.5;
}

.price-info {
  display: flex;
  align-items: baseline;
  gap: 5px;
}

.price {
  font-size: 24px;
  font-weight: bold;
  color: #303133;
}

.period {
  color: #909399;
}

.subscription-actions {
  display: flex;
  justify-content: flex-end;
}
</style> 